<template>
  <div
    v-if="this.currentPath"
    :class="{ 'personal-sidebar': true, 'fixed-style': fixedStyle }"
  >
    <!-- <div v-if="this.currentPath" class="personal-sidebar"> -->
    <!-- router -->
    <el-menu
      :default-active="currentPath"
      :unique-opened="true"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#364150"
      text-color="#333"
      active-text-color="#a20a0e"
      router
    >
      <template v-for="(item, index) in navigationList">
        <!-- 含有二级菜单 -->
        <el-submenu
          v-if="
            item.personalCenterSubSubheadings &&
            item.personalCenterSubSubheadings.length > 0
          "
          :key="index"
          :index="item.link"
        >
          <template slot="title">
            <span class="main-title">{{ item.title }}</span>
            <span v-if="item.number" class="message-num">{{
              item.number > 99 ? "99+" : item.number
            }}</span>
          </template>

          <template
            v-for="(subItem, subIndex) in item.personalCenterSubSubheadings"
          >
            <!-- 二级菜单 -->
            <el-menu-item
              :key="subIndex"
              :index="subItem.link"
              v-if="
                (isMajor && subItem.id != 28) || (!isMajor && subItem.id != 27)
              "
            >
              <!-- isMajor   id:27已购回答 28我的回答-->

              <span class="sub-title"> {{ subItem.subheadingTitle }}</span>
              <span v-if="subItem.number" class="submessage-num">{{
                subItem.number > 99 ? "99+" : subItem.number
              }}</span>
            </el-menu-item>
          </template>
        </el-submenu>
        <!-- 仅一级菜单 -->
        <el-menu-item
          v-else
          :key="index"
          :index="item.link == '/1' ? '' : item.link"
          @click="toTips(item.link)"
        >
          <template slot="title">
            <span class="main-title">{{ item.title }}</span>
            <span v-if="item.number" class="message-num">{{
              item.number > 99 ? "99+" : item.number
            }}</span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import * as personalApi from "@/api/personalApi";
import * as strategyApi from "@/api/strategyApi";
export default {
  data() {
    return {
      currentPath: "", //个人中心默认路由
      navigationList: [],
      fixedStyle: false,
      isMajor: false,
    };
  },
  watch: {
    $route: function (to, from) {
      this.showNavigation();
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 获取菜单
    showNavigation() {
      personalApi.showNavigation().then((res) => {
        if (res.data.code == "200") {
          this.navigationList = res.data.data;
          if(localStorage.getItem("role") == 'SDP'){
            this.navigationList.push({
              link: "/personalCenter/allStandard",
              number: 0,
              personalCenterSubSubheadings: null,
              title: "施工标准"
            })
            this.navigationList.push({
              link: "/personalCenter/weeklyPlan",
              number: 0,
              personalCenterSubSubheadings: null,
              title: "周计划"
            })
          }
          // 重定向侧边栏
          this.currentPath = this.$route.path;
          // console.log(this.$route.path);
        }
      });
    },
    handleScroll: function () {
      if (document.documentElement.scrollTop >= 150) {
        this.fixedStyle = true;
        // 改变之后就要移除滚动监听事件 不移除
        // window.removeEventListener("scroll", this.handleScroll);
      } else {
        this.fixedStyle = false;
      }
    },
    toTips(link) {
      if (link == "/1") {
        this.$message.info("敬请期待！");
      }
    },
    judgeIsMajorAnswer() {
      strategyApi.judgeIsMajorAnswer({}).then((res) => {
        if (res.data.code == "200") {
          this.isMajor = res.data.data;
        }
      });
    },
  },
  created() {
    this.fixedStyle = false;
    this.showNavigation();
    this.judgeIsMajorAnswer();
  },
  mounted() {
    // 监控滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang='scss'>
// 固定侧边栏
.fixed-style {
  position: fixed;
  top: 0;
}
.personal-sidebar {
  margin-top: 6px;
  width: 260px;
  text-align: center;
  float: left;

  ul {
    width: 100%;
    border: none;
  }

  .el-menu {
    background: none !important;
  }
  .el-menu-item,
  .el-submenu__title {
    background: #fff !important;
    margin-top: 4px;
  }
  .is-active .el-submenu__title {
    color: #a20a0e !important;
    position: relative;
  }
  .is-active .main-title::before {
    width: 4px;
    height: 20px;
    background: rgba(162, 10, 14, 1);
    border-radius: 2px;
    overflow: hidden;
    display: block;
    content: "";

    position: absolute;
    left: 74px;
    top: 19px;
  }

  .main-title {
    font-size: 20px;
    font-weight: bold;
  }
  .main-title:hover,
  .sub-title:hover {
    color: #a20a0e;
  }
  .sub-title {
    font-size: 16px;
  }
  .message-num {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 22px;
    text-align: center;
    background: #a20a0e;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    position: absolute;
    top: 19px;
    right: 60px;
  }
  .submessage-num {
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 20px;
    text-align: center;
    background: #a20a0e;
    color: #fff;
    border-radius: 50%;
    font-size: 10px;
    position: absolute;
    top: 16px;
    right: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personalSidebar.vue